/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";

import {colors} from "nxtconstants";
import {WealthyEnv} from "helpers";

import {
  container
} from "../common";

const bannerImg = `${WealthyEnv.BROKING_CDN_URL}/pricing-banner-image.png`;
const wealthyLogo = `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-new-purple-logo.svg`;
const underlineGraphic = `url(${WealthyEnv.BROKING_CDN_URL}/underline-vector.png)`;

const PricingBanner = () => {
  return (
    <>
      <HomeBannerWrapper>
        <LogoContainer>
          <HomeLink href={WealthyEnv.URL}>
            <LogoIcon
              alt="wealthy-logo"
              src={wealthyLogo}
            />
          </HomeLink>
        </LogoContainer>
        <BannerContentWrapper>
          <Content>
            <Tagline>Transparent pricing. <br />No hidden <br />brokerage charges.</Tagline>
          </Content>
          <IconSection>
            <IconThumbsUp
              alt="Pricing"
              src={bannerImg}
            />
          </IconSection>
        </BannerContentWrapper>
      </HomeBannerWrapper>
    </>
  );
};

const HomeBannerWrapper = styled.div`
  background-color: ${colors.magnolia};
  padding-bottom: 3rem;

  @media (max-width: 576px) {
    padding-bottom: 0;
  }
`;

const LogoContainer = styled.div`
  padding: 3.5rem 0 2.5rem 4.5rem;

  @media (max-width: 1220px){
    padding-left: 2.4rem;
    padding-right: 2.4rem;
  }
`;

const HomeLink = styled.a``;

const LogoIcon = styled.img`
  height: 3.8rem;

  @media (max-width: 768px) {
    height: 32px;
    margin-bottom: 4.2rem;
  }
`;

const BannerContentWrapper = styled(container)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3rem 0 7rem;

  @media (max-width: 1220px) {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  @media (max-width: 576px) {
    padding-top: 0;
  }
`;

const Content = styled.div`
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 0;
    height: 20px;
    width: 100%;
    background-image: ${underlineGraphic};
    background-size: contain;
    background-repeat: no-repeat;
  }
`;

const Tagline = styled.h1`
  font-size: 5.2rem;
  font-family: 'Marcellus', serif;
  font-weight: 400;
  line-height: 1.3;

  @media (max-width: 576px) {
    font-size: 3.6rem;
  }
`;

const IconSection = styled.div`
  @media (max-width: 992px) {
    width: 50%;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

const IconThumbsUp = styled.img`
  width: 45rem;

  @media (max-width: 992px) {
    width: 100%;
  }
`;


export default PricingBanner;
